import React from 'react';

import styled from 'styled-components';

import TextField from '@material-ui/core/TextField';
const StyledTextField = styled(TextField)`
  && { width: 100%; }
`

const TextToSpeech = ({value, setValue, i18next}) => {



  const handleChange = (event) => setValue(event.target.value);

  return (
    <StyledTextField
      id="standard-name"
      label={i18next.t("Text to speech")}
      value={value}
      onChange={handleChange}
      margin="normal"
      multiline
      rows="4"
      variant="outlined"
      inputProps={{style: i18next.language === "fa" ? {fontFamily: "BYekan"} : {}}} // font of input text
      InputLabelProps={{style: i18next.language === "fa" ?{fontFamily: "BYekan"} : {}}} // font of input label
  />
  )
};

export default TextToSpeech;